// ABOUTME: The forgiven sky behind the clouds scene on 4B and 5B: the sky-forgiven gradient from the header down to the horizon.
// ABOUTME: Decoration only. It fades in when the press happened on this screen and is simply there on arrival or under reduced motion.

import { Box } from '@mui/material';
import { useHorizon } from '../../crossing/useHorizon';
import { useCrossingReducedMotion } from '../../crossing/useReducedMotion';
import { CROSSING_SKY_FORGIVEN_GRADIENT } from '../../../../theme/crossingTokens';
import { SCENE_IN } from '../clouds/weatherVignetteKeyframes';

interface ForgivenSkyLayerProps {
  fadeIn?: boolean; // the prototype's wxSceneIn: 0.8 s ease, after 0.15 s
}

export default function ForgivenSkyLayer({ fadeIn = false }: ForgivenSkyLayerProps) {
  const reducedMotion = useCrossingReducedMotion();
  const { line } = useHorizon();
  const fades = fadeIn && !reducedMotion;
  return (
    <Box
      aria-hidden
      data-testid="sky-forgiven-layer"
      sx={{
        position: 'fixed', top: 0, left: 0, right: 0, height: line, zIndex: -1, pointerEvents: 'none',
        background: CROSSING_SKY_FORGIVEN_GRADIENT,
        opacity: fades ? 0 : 1,
        animation: fades ? `${SCENE_IN} 0.8s ease forwards 0.15s` : undefined,
      }}
    />
  );
}
